import { useMemo } from 'react';

import useEmployeeEmailField from '../CommunicationChannels/hook/useEmployeeEmailField';
import useEmployerEmailField from '../CommunicationChannels/hook/useEmployerEmailField';

export default () => {
  const employeeEmailField = useEmployeeEmailField({ isEditMode: true });
  const employerEmailField = useEmployerEmailField({ isEditMode: true });

  const fields = useMemo(() => [
    employeeEmailField,
    employerEmailField,
  ], [employeeEmailField, employerEmailField]);

  return fields;
};
